import { useState } from 'react';

export type LeadType = 'order' | 'callback' | 'consultation' | 'catalog' | 'calculator' | 'certificate' | 'transport';

interface LeadFormData {
  leadType: LeadType;
  productName?: string;
  productId?: string;
  calculatedPrice?: number;
}

export const useLeads = () => {
  const [isLeadFormOpen, setIsLeadFormOpen] = useState(false);
  const [isTransportCalculatorOpen, setIsTransportCalculatorOpen] = useState(false);
  const [leadFormData, setLeadFormData] = useState<LeadFormData>({
    leadType: 'callback'
  });

  const openLeadForm = (data: LeadFormData) => {
    setLeadFormData(data);
    setIsLeadFormOpen(true);
  };

  const closeLeadForm = () => {
    setIsLeadFormOpen(false);
  };

  const openTransportCalculator = () => {
    setIsTransportCalculatorOpen(true);
  };

  const closeTransportCalculator = () => {
    setIsTransportCalculatorOpen(false);
  };

  const handleTransportCalculation = (data: any) => {
    // Обработка данных калькулятора транспорта
    console.log('Transport calculation data:', data);
    // Здесь можно отправить данные в CRM или аналитику
  };

  // Быстрые методы для разных типов лидов
  const requestCallback = () => {
    openLeadForm({ leadType: 'callback' });
  };

  const requestConsultation = () => {
    openLeadForm({ leadType: 'consultation' });
  };

  const requestCatalog = () => {
    openLeadForm({ leadType: 'catalog' });
  };

  const orderProduct = (productName: string, productId: string, price?: number) => {
    openLeadForm({
      leadType: 'order',
      productName,
      productId,
      calculatedPrice: price
    });
  };

  const requestCalculation = (calculatedPrice?: number) => {
    openLeadForm({
      leadType: 'calculator',
      calculatedPrice
    });
  };

  const requestCertificateInfo = (certificateName?: string) => {
    openLeadForm({
      leadType: 'certificate',
      productName: certificateName
    });
  };

  return {
    isLeadFormOpen,
    isTransportCalculatorOpen,
    leadFormData,
    openLeadForm,
    closeLeadForm,
    openTransportCalculator,
    closeTransportCalculator,
    handleTransportCalculation,
    requestCallback,
    requestConsultation,
    requestCatalog,
    orderProduct,
    requestCalculation,
    requestCertificateInfo
  };
};

export default useLeads;